
import FormField from "components/inputs/FormField/FormField";
import ClassificationForm from "components/modalForms/ClassificationForm/ClassificationForm";

import styles from "./map-manual-point-modal-form.module.scss";

interface MapManualPointModalFormInterface {
  formik: any;
  isLock?: boolean;
  classificationsData: any;
  currentClassificationData: any;
  currentType: any;
  setCurrentType: (option: any) => void;
  formFields: any;
}

const MapManualPointModalForm = ({
  formik,
  isLock,
  classificationsData,
  currentClassificationData,
  currentType,
  setCurrentType,
  formFields
}: MapManualPointModalFormInterface) => {
  return (
    <div className={styles["modal__form"]}>
      <FormField
        name={"generalPointData.name"}
        label="Point name"
        placeholder="Name point"
        disabled={isLock}
      />
      <div className={styles["form__coordinates"]}>
        <FormField
          name={"generalPointData.coordinates.lat"}
          label="Latitude"
          disabled={isLock}
        />
        <FormField
          name={"generalPointData.coordinates.lng"}
          label="Longitude"
          disabled={isLock}
        />
      </div>
      <ClassificationForm
        formik={formik}
        classificationsData={classificationsData}
        currentClassificationData={currentClassificationData}
        currentType={currentType}
        setCurrentType={setCurrentType}
        formFields={formFields}
      />
      {/* <div className={styles["form__diameter"]}>
        <FormField
          name={"generalPointData.object_diameter"}
          label="Diameter"
          type="number"
          disabled={isLock}
        />
        <label
          className={classNames(styles["diameter__dimensions"], {
            [styles["silver-color"]]: isLock
          })}
        >
          m
        </label>
      </div> */}
    </div>
  );
};

export default MapManualPointModalForm;
